<template>
	<div v-loading="loading" class="base_scroll_page">
		<!-- 主体区域 -->
		<div class="b_scroller">
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						label="头像"
					>
						<template slot-scope="scope">
							<img :src="scope.row.avatar" alt="" style="width: 48px;">
						</template>
					</el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="mobile"
						label="手机"
					>
					</el-table-column>
					<el-table-column
						prop="sexLabel"
						label="性别"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<!-- slot-scope="scope" -->
						<template >
							<el-button>企业微信</el-button>
							<el-button>客户</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<wx v-model="wx_display"></wx>
		
		<user v-model="user_display"></user>
	</div>
</template>

<script>
	import Wx from './components/wx.vue';
	import User from './components/user.vue';
	import Api from '../../../../../api/index.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				
				tableData: [],
				currentPage: 1,
				total: 0,
				
				wx_display: false,
				
				user_display: false
			}
		},
		methods: {
			/************************ @Events *******************************/
			// 点击页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			
			/************************ @Function *******************************/
			// 获取列表数据
			getData() {
				this.loading = true;
				Api.findTrainer().then((res) => {
					if (res.data.success) {
						this.loading = false;
						console.log(res);
						// let list = [];
						// res.data.data.records.forEach(v => {
						// 	list.push({
						// 		id: v.id,
						// 		mid: v.machineId,
						// 		createDate: v.productionDate,
						// 		createNumber: v.productionSerial,
						// 		sellDate: v.saleDate,
						// 		addr: `${ v.provinceName }${ v.cityName }${ v.areaName }`,
						// 		uname: v.userName,
						// 		type: v.userType == 1 ? '门店' : '用户',
						// 		model: v.modelName,
						// 		chipId: v.chipId,
						// 		version: v.swVersion,
						// 		billing: that.mapBillingFlagToLabel(v.feeType),
						// 		remain: v.remainInfo
						// 	});
						// });
						// that.tableData = list;
						// that.total = res.data.data.total;
					} else {
						this.loading = false;
						this.$message.error(res.data.message);
					}
				}, (e) => {
					this.loading = false;
					this.$message.error(e.message);
				});
			}
		},
		components: {
			Wx,
			User
		}
	}
</script>

<style>
</style>
